import { IOSettingsTranslation } from 'locales/de/pages/ioSettings';

const en: IOSettingsTranslation = {
  year: 'Year',
  semesterType: 'Semester type',
  examRegistration: 'Exam registration',
  edit: 'Edit'
};

export default en;
